/**
 * useFollowingIds — set of user ids the current user follows.
 *
 * Cached so all follow checks (FollowContext, profile pages, lists) share one
 * source of truth. Mutations in `useFollowMutations` invalidate this key.
 */
import { useQuery } from "@tanstack/react-query";
import { listFollowingIds } from "@/data/raw";
import { keys } from "@/data/keys";

export function useFollowingIds(userId: string | undefined) {
  return useQuery<Set<string>>({
    queryKey: userId
      ? keys.follows.followingIds(userId)
      : keys.follows.followingIds("__none__"),
    enabled: Boolean(userId),
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await listFollowingIds(userId!);
      if (error) throw error;
      return new Set<string>((data ?? []).map((f) => f.following_id as string));
    },
  });
}
